import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from 'inversify';
import { Symbols } from '@/symbols';
let MessageSendService = class MessageSendService {
    constructor(MessageSendApi) {
        this.MessageSendApi = MessageSendApi;
    }
    getMessageList(queriesData) {
        const res = this.MessageSendApi.getMessageList(queriesData);
        return res;
    }
};
MessageSendService = __decorate([
    injectable(),
    __param(0, inject(Symbols.MessageSendApi)),
    __metadata("design:paramtypes", [Object])
], MessageSendService);
export { MessageSendService };
